import { Component, OnInit } from '@angular/core';
import { MembersPortalService } from '../../../angular-wallet-base/services/members-portal.service';
import { AlertController, ModalController, NavController, Platform, ToastController } from '@ionic/angular';
import { AgxTosComponent } from '../agx-tos/agx-tos.component';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { getSideMenuStatus } from 'src/app/angular-wallet-base/store/appSettings';
import { take } from 'rxjs/operators';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';

@Component({
  selector: 'app-investment-contracts',
  templateUrl: './investment-contracts.component.html',
  styleUrls: ['./investment-contracts.component.scss'],
})
export class InvestmentContractsComponent implements OnInit {
  public agreementsLoader = true;
  public agreements: any = [];
  public tosStatusLoader = true;
  public tosStatus: any = [];
  public tosObj = {};
  public isDesktopMode: boolean;

  constructor(
    private membersPortalService: MembersPortalService,
    private modalController: ModalController,
    public appMode: AppModeService,
    public store: Store<AppState>,
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  async ngOnInit() {
    if (!this.agreements.length) {
      this.agreements = await this.membersPortalService.getAgreedToTos();
      this.agreementsLoader = false;
      Logger.info('agreements', this.agreements);
    }
    if (!this.tosStatus.length) {
      this.tosStatus = await this.membersPortalService.getTosAndStatus();
      this.tosStatusLoader = false;
      Logger.info('tosStatus', this.tosStatus);
    }
  }

  getContractTitle(tosContract) {
    const title = tosContract.name === 'agx_tos' ? 'AGX' : 'LODE';
    let titleToShow = '';
    let lang = '';
    switch (tosContract.lang) {
      case 'en':
        lang = 'English';
        break;
      case 'es':
        lang = 'Spanish';
        break;
      case 'fr':
        lang = 'French';
        break;
    }
    titleToShow += title + ' ' + lang + ' ' + 'ver. ' + tosContract.version;
    return titleToShow;
  }

  async goToTosComponent(tos) {
    this.tosObj = tos;
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    const breakpoint = (tos.agreements_id) ? 0.45 : 0.85;

    let cssClass = 'agx-tos-modal';
    cssClass += (this.isDesktopMode && !tos.agreements_id) ? '-desktop' : '';
    cssClass += (this.isDesktopMode && tos.agreements_id) ? '-agreement' : '';
    cssClass += (!sideMenuHidden && this.isDesktopMode) ? ' with-side-menu' : '';

    const modal = await this.modalController.create({
      component: AgxTosComponent,
      cssClass,
      initialBreakpoint: (!this.isDesktopMode) ? breakpoint : undefined,
      breakpoints: (!this.isDesktopMode) ? [0, 0.45, 0.85, 1] : undefined,
      componentProps: {
        tosObj: this.tosObj
      }
    });
    await modal.present();
  }
}
